import { SearchOutlined } from '@ant-design/icons';
import { ItemType } from 'antd/lib/menu/interface';

type TDiscoverNewClinicsListItemProps = {
    onOpenModal: () => void;
};

export const getDiscoverNewClinicsListItem = ({
    onOpenModal,
}: TDiscoverNewClinicsListItemProps): ItemType => ({
    key: 'discover-new-clinics',
    label: 'Discover New Clinics',
    icon: <SearchOutlined />,
    onClick: () => {
        onOpenModal();
    },
});
